import { render } from "./Home.vue?vue&type=template&id=35a5f267"
import script from "@/assets/projectJs/Home.js?vue&type=script&lang=js"
export * from "@/assets/projectJs/Home.js?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__